<template>
  <div class="race-profile" v-if="isLoaded">
    <div class="profile-title">赛事报名信息</div>
    <van-cell-group>
      <van-field v-model="form.name" label="姓名" placeholder="请填写姓名" />
      <div class="help_text">请填写真实姓名</div>

      <van-field v-model="form.mobile" type="tel" label="手机号码" placeholder="请填写手机号码" />
      <van-field v-model="form.id_card" label="身份证号" placeholder="请填写身份证号" @change="handlerChange" />
      <generic-picker v-model="form.gender" :columns="genderList" title="性别" />
      <date-picker title="出生日期" v-model="form.birthday" />
      <generic-picker v-model="form.blood" :columns="bloodList" title="血型" />
      <van-field v-model="form.contact_name" label="紧急联系人" placeholder="请填写紧急联系人" />
      <van-field v-model="form.contact_phone" label="紧急联系人电话" label-width="110px" placeholder="请填写紧急联系人电话" />
      <generic-picker v-model="form.clothing_size" :columns="clothingSizeList" title="衣服尺码" />

      <div class="cert_title">参赛证明</div>
      <div class="help_text">提供两年内20公里以上越野完赛证书或半程马拉松的完赛证书</div>
      <div class="photo_contrain">
        <div v-for="(item, index) in fileObjs" :key="index" class="photo">
          <img :src="form.cert_img_url? form.cert_img_url : item.content" @click.stop="onPreview(index)">
          <div class="close" @click="delPic(index)"><van-icon name="cross" /></div>
        </div>
        <van-uploader v-if="showUploadBtn" class="add_photo" :after-read="onRead">
          <van-icon name="photograph" />
        </van-uploader>
      </div>

    </van-cell-group>

    <bottom-btn class="bgwhite select-race" title="确认信息" :fixed="false" @click.native="gotoSave" />
  </div>
</template>

<script>
import { validatePhone, validateIdCard, parseBirthdayFromIdCard } from '@/utils/validation'
import { mapGetters } from 'vuex'
import { Toast, Cell, CellGroup, Field, Uploader, Icon, ImagePreview } from 'vant'
import GenericPicker from '@/components/Picker/GenericPicker'
import DatePicker from '@/components/Picker/DatePicker'
import BottomBtn from '@/components/BottomBtn'
import { uploadImageToOss } from '@/api/upload'
import { getUploadParams } from '@/utils/upload'
import { setRaceProfile } from '@/api/race'

export default {
  name: 'raceprofile',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    GenericPicker,
    DatePicker,
    BottomBtn
  },
  computed: {
    ...mapGetters([
      'ossToken',
      'userRaceProfile'
    ]),
    showUploadBtn () {
      return this.images.length < this.picLimit
    }
  },
  data () {
    return {
      isLoaded: false,
      raceId: null,
      ruleId: null,
      genderList: ['男', '女'],
      bloodList: ['AB', 'A', 'B', 'O'],
      clothingSizeList: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      picLimit: 1,
      fileObjs: [],
      images: [],
      form: {
        name: '',
        gender: null,
        mobile: '',
        id_card: '',
        birthday: null,
        blood: null,
        clothing_size: null,
        contact_name: '',
        contact_phone: '',
        cert_img: '',
        cert_img_url: ''
      }
    }
  },
  created () {
    this.raceId = this.$route.params.race_id || ''
    this.ruleId = this.$route.query.rule || ''
    if (!this.raceId || !this.ruleId) {
      Toast('页面错误')
      return
    }
    this.isLoaded = true
    if (this.userRaceProfile) {
      this.form = Object.assign({}, this.userRaceProfile)

      this.fileObjs = [this.form.cert_img_url]
      this.images = [this.form.cert_img_url]
    }
  },
  methods: {
    onRead (file) {
      this.fileObjs.push(file)
      this.images.push(file.content)
    },
    delPic (index) {
      this.fileObjs.splice(index, 1)
      this.images.splice(index, 1)
    },
    onPreview (index) {
      ImagePreview({
        images: this.images,
        startPosition: index
      })
    },
    handlerChange (e) {
      const res = parseBirthdayFromIdCard(this.form.id_card)
      this.form.birthday = res
      console.log(this.form.birthday)
    },
    validForm () {
      console.log(this.form)
      if (!this.form.name) {
        Toast('请填写姓名')
        return false
      }
      if (!this.form.mobile) {
        Toast('请填写手机号码')
        return false
      }
      // 验证手机号码
      if (!validatePhone(this.form.mobile)) {
        Toast('手机号码有误，请重填')
        return false
      }
      if (!this.form.id_card) {
        Toast('请填写身份证号')
        return false
      }
      // 验证身份证
      if (!validateIdCard(this.form.id_card)) {
        Toast('身份证号有误，请重填')
        return false
      }
      if (!this.form.gender) {
        Toast('请选择性别')
        return false
      }
      if (!this.form.birthday) {
        Toast('请填写出生日期')
        return false
      }
      if (!this.form.blood) {
        Toast('请选择血型')
        return false
      }
      if (!this.form.contact_name) {
        Toast('请填写紧急联系人')
        return false
      }
      if (!this.form.contact_phone) {
        Toast('请填写紧急联系人电话')
        return false
      }
      return true
    },
    async gotoSave () {
      if (!this.validForm()) {
        return false
      }

      if (!this.form.cert_img) {
        if (!this.fileObjs.length) {
          Toast('请上传参赛证明')
          return false
        }

        Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
        await this.uploadPics()
        Toast.clear()
      }
      this.$store.dispatch('SetUserRaceProfile', this.form)

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      const res = await setRaceProfile({
        race_id: this.raceId,
        profile: this.form
      })
      Toast.clear()

      this.$router.push(`/race_order/${this.raceId}/confirm?rule=${this.ruleId}&profile=${res.data.profile_id}`)
    },
    async uploadPics () {
      if (!this.fileObjs.length) {
        return false
      }

      await this.$store.dispatch('GetOssToken', 'race_enroll_cert')

      let pictures = []
      for (let index = 0; index < this.fileObjs.length; index++) {
        const fileObj = this.fileObjs[index]
        const formData = getUploadParams(this.ossToken, fileObj.file)

        await uploadImageToOss(this.ossToken.host, formData)
        pictures.push(formData.get('key'))
      }

      this.form.cert_img = pictures[0]
      this.form.cert_img_url = this.ossToken.host + '/' + pictures[0]
    }
  }
}
</script>

<style scoped lang="scss">
.help_text {
  color: #5e6d82;
  font-size: 28px;
  padding: 10px 0 10px 30px;
}
.profile-title {
  font-size: 32px;
  padding: 30px 20px;
}
.cert_title {
  font-size: 28px;
  padding: 10px 0 10px 30px;
}
.photo_contrain {
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  .photo {
    width: 150px;
    height: 150px;
    margin-left: 30px;
    margin-top: 20px;
    position: relative;
    box-sizing: border-box;
    img {
      width: 150px;
      height: 150px;
      object-fit: cover;
    }
    .close {
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
      font-size: 28px;
      width: 40px;
      height: 40px;
      border-bottom-left-radius: 6px;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .add_photo {
    width: 150px;
    height: 150px;
    margin-left: 30px;
    margin-top: 20px;
    box-sizing: border-box;
    border: 1PX solid #ebedf0;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
